<template>
  <div class="my-page" :class="{'red-bgc':styleColor}">
    <div class="page-header disFlex fc Flex-between">
      <img src="https://j.weizan.cn/youxiang/header-bg.png" class="bg-img" />
      <div class="header-left disFlex fc" style="max-width:77%;">
        <div class="avatar">
          <img :src="avatarUrl" class="avatar-img" />
        </div>
        <div class="info disFlex vertical Flex-between">
          <div>{{userName}}</div>
          <div class="disFlex">
            <div class="ticket-flag">{{buyState===1?'已购券':'未购券'}}</div>
          </div>
        </div>
      </div>
      <div class="header-right disFlex Flex-center fvc" :class="{'red-bgc-h':styleColor}">
        <img src="https://j.weizan.cn/youxiang/scane.png" class="scane-img" />
        <div class="scane-tip" @click="scaneCode">扫码签到</div>
      </div>
    </div>
    <div class="page-body">
      <div class="info-box">
        <div class="info-item disFlex fc Flex-between" @click="viewInfo(0)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/jiangli.png" class="item-img" />
            <div class="info-title">我的奖励</div>
          </div>
          <div class="info-right disFlex Flex-center">
            <div class="info-data">￥{{reward?reward:0}}</div>
            <div class="next-page"></div>
          </div>
        </div>
        <div class="line"></div>

        <div class="info-item disFlex fc Flex-between" @click="viewInfo(1)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/daiyanrenhuodong.png" class="item-img" />
            <div class="info-title">代言人奖励</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="info-item disFlex fc Flex-between" @click="viewInfo(2)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/daijinquan.png" class="item-img" />
            <div class="info-title">代金券</div>
          </div>
          <div class="info-right disFlex Flex-center">
            <div class="info-data">{{couponData}}张</div>
            <div class="next-page"></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="info-item disFlex fc Flex-between" @click="viewInfo(3)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/miaosha.png" class="item-img" />
            <div class="info-title">我的秒杀</div>
          </div>
          <div class="info-right disFlex Flex-center">
            <div class="info-data">{{seckillData}}单</div>
            <div class="next-page"></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="info-item disFlex fc Flex-between" @click="viewInfo(4)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/lipin.png" class="item-img" />
            <div class="info-title">集赞礼品</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="info-item disFlex fc Flex-between" @click="viewInfo(5)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/zhibodingdan.png" class="item-img" />
            <div class="info-title">直播订单</div>
          </div>
          <div class="info-right disFlex Flex-center">
            <div class="info-data">{{liveData}}单</div>
            <div class="next-page"></div>
          </div>
        </div>
        <div class="line"></div>
        <a class="info-item disFlex fc Flex-between" :href="`tel:${phone}`">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/tousurexian.png" class="item-img" />
            <div class="info-title">投诉热线</div>
          </div>
          <div class="info-right disFlex Flex-center"></div>
        </a>
        <div class="line"></div>
        <div class="info-item disFlex fc Flex-between" @click="viewInfo(6)">
          <div class="info-left disFlex Flex-center">
            <img src="https://j.weizan.cn/youxiang/lipin.png" class="item-img" />
            <div class="info-title">逛店勋章</div>
          </div>
          <div class="info-right disFlex Flex-center">
            <div class="next-page"></div>
          </div>
        </div>
      </div>
      <!-- <div class="medal-area">
        <div class="area-head disFlex fc Flex-between">
          <div class="title">逛店勋章</div>
          <div class="rule disFlex fc" @click="viewRule">
            <div>逛店规则</div>
            <div class="ask">?</div>
          </div>
        </div>
        <div class="area-body disFlex fc">
          <div
            class="shop-item disFlex vertical fvc"
            v-for="(item,index) in shopVisitedData"
            :key="index"
          >
            <div v-if="item.goShopStatus" class="logo-box f v fc">
              <img src="https://j.weizan.cn/youxiang/yiguangdian.png?v=1" class="pic" />
              <img :src="item.brandLogo" class="bg" />
            </div>
            <div v-else class="logo-box f v fc">
              <img src="https://j.weizan.cn/youxiang/weiguangdian.png?v=2" class="pic" />
              <img :src="item.brandLogo" class="bg" />
            </div>
            <div>{{item.brandName}}</div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <van-dialog v-model="ruleFlag" :close-on-click-overlay="true" title="逛店规则">
      <pre class="pre">{{rule}}</pre>
    </van-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      avatarUrl: localStorage.getItem("avatarUrl"),
      userName: localStorage.getItem("userName"),
      seckillData: 0,
      couponData: 0,
      liveData: 0,
      reward: 0,
      phone: "",
      buyState: 0,
      shopVisitedData: [],
      rule: "",
      ruleFlag: false,
      styleColor: true,
    };
  },
  created() {
    this.$initWXSDK({}, () => {
      this.$utils.getLocation();
    });
    this.$store.commit("setLoading", true);
    this.getMyInfoData();
    this.getShopVisitedData();
    // this.getRule();
    this.getActInfo();
  },
  methods: {
    getActInfo() {
      this.$http.post("/v1/home/activity").then((res) => {
        if (res.code === 0) {
          this.styleColor = res.data.style == "red" ? true : false;
        }
      });
    },
    getRule() {
      this.$http.post("/v1/finance/config/go_shop_rule").then((res) => {
        this.rule = res.data;
      });
    },
    getShopVisitedData() {
      this.$http.post("/v1/finance/config/go_shop_list").then((res) => {
        this.shopVisitedData = res.data;
      });
    },
    getMyInfoData() {
      this.$http.post("/v1/finance/account/reward").then((res) => {
        this.$store.commit("setLoading", false);
        this.seckillData = res.data.seckill;
        this.reward = res.data.total;
        this.couponData = res.data.card;
        this.liveData = res.data.live;
        this.phone = res.data.complainMobile;
        this.buyState = res.data.buyState;
      });
    },
    viewInfo(e) {
      let url = "";
      let tmp = localStorage.getItem("preheatPath") || "/prehddd";
      let tmp2 = localStorage.getItem("likedetailPath") || "/likedetailbase";

      switch (e) {
        case 0:
          url = "/my/myReward";
          break;
        case 1:
          url = "/my/spokesmanReward";
          break;
        case 2:
          url = "/my/myCoupon";
          break;
        case 3:
          url = "/my/mySeckill";
          break;
        case 4:
          url = `${tmp2}?self=true`;
          // url = "/likedetailthree?self=true";
          break;
        case 5:
          url = "/my/myLiveOrder";
          break;
        case 6:
          url = "/my/myGoshop";
          break;
        default:
          url = tmp;
          break;
      }
      this.$router.push({
        path: url,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    viewRule() {
      this.ruleFlag = true;
    },
    scaneCode() {
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      });
    },
  },
};
</script>

<style lang="less" scoped>
.red-bgc {
  background: rgba(184, 0, 0, 0.75) !important;
}
.red-bgc-h {
  background: rgba(150, 0, 0, 1) !important;
}
.my-page {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: #003078;
  padding-bottom: 55px;
  .page-header {
    padding: 0 15px;
    position: relative;
    .bg-img {
      position: absolute;
      right: 0;
      top: 0;
      width: 151px;
      height: 190px;
    }
    .avatar {
      width: 70px;
      height: 70px;
      background: rgba(255, 255, 255, 1);
      border-radius: 50%;
      margin: 30px 0;
      .avatar-img {
        width: 70px;
        height: 70px;
        background: rgba(255, 255, 255, 1);
        border-radius: 50%;
      }
    }
    .info {
      margin-left: 13px;
      font-size: 20px;
      height: 70px;

      font-family: PingFang SC;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      .ticket-flag {
        height: 20px;
        line-height: 20px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;

        padding: 0 8px;
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
      }
    }
    .header-right {
      z-index: 1000;
      width: 75px;
      height: 26px;
      background: rgba(0, 34, 86, 1);
      border-radius: 5px;
    }
    .scane-img {
      width: 12px;
      height: 12px;
      margin-right: 10px;
    }
    .scane-tip {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
  }
  .page-body {
    min-height: calc(100vh - 171px);
    background: rgba(255, 255, 255, 1);
    border-radius: 15px 15px 0px 0px;
    padding: 7px 16px 0;
  }
  .info-box {
    .line {
      width: 315px;
      height: 1px;
      background: rgba(245, 246, 247, 1);
      margin-left: auto;
    }
    .info-item {
      padding: 20px 0;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
      .item-img {
        width: 18px;
        height: 18px;
        margin-right: 12px;
      }
      .info-right {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(177, 177, 177, 1);
      }
      .info-title {
        color: #353535 !important;
      }
    }
  }
  .medal-area {
    .area-head {
      .title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(53, 53, 53, 1);
      }
      .rule {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(105, 105, 105, 1);
        .ask {
          font-size: 10px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(203, 151, 76, 1);
          line-height: 16px;
          text-align: center;
          width: 16px;
          height: 16px;
          background: rgba(255, 209, 143, 1);
          opacity: 0.5;
          border-radius: 8px;
          margin-left: 10px;
        }
      }
    }
    .area-body {
      padding: 16px 0;
      overflow-x: scroll;
      .shop-item {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(53, 53, 53, 1);
        margin-right: 34px;

        div {
          margin-top: 10px;
        }
      }
    }
  }
  .pre {
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
    font-family: PingFang SC;
    margin: 0 10px;
    text-align: left;
  }
  .logo-box {
    width: 90px;
    height: 64px;
    position: relative;
    overflow: hidden;
    .bg {
      width: 85px;
      height: 43px;
    }
    .pic {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 100;
      width: 90px;
      height: 64px;
    }
  }
}
</style>